import React from 'react';
import { InfoIcon } from '../icons/FinanceIcons';

// Card Component (Stripe style)
export const Card = ({ children, className = '', noPadding = false, style = {} }) => (
  <div style={{
    backgroundColor: 'white',
    borderRadius: '8px',
    border: '1px solid #e5e5e5',
    padding: noPadding ? 0 : '20px',
    ...style
  }}>
    {children}
  </div>
);

// Card Header
export const CardHeader = ({ title, action, tooltip }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      <h3 style={{ fontWeight: '500', color: '#1a1a1a', margin: 0, fontSize: '15px' }}>{title}</h3>
      {tooltip && <InfoIcon tooltip={tooltip} />}
    </div>
    {action}
  </div>
);

// Metric Display with badge style for changes
export const MetricValue = ({ value, change, changeType, subtitle }) => {
  const getBadgeStyles = () => {
    if (changeType === 'positive') {
      return {
        backgroundColor: '#d1fae5',
        color: '#059669'
      };
    } else if (changeType === 'negative') {
      return {
        backgroundColor: '#fee2e2',
        color: '#dc2626'
      };
    }
    return {
      backgroundColor: '#f3f4f6',
      color: '#6b7280'
    };
  };

  const badgeStyles = getBadgeStyles();

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'nowrap' }}>
        <span style={{ fontSize: '1.5rem', fontWeight: '600', color: '#1a1a1a', whiteSpace: 'nowrap' }}>{value}</span>
        {change && (
          <span style={{
            fontSize: '12px',
            fontWeight: '600',
            backgroundColor: badgeStyles.backgroundColor,
            color: badgeStyles.color,
            padding: '3px 8px',
            borderRadius: '4px',
            whiteSpace: 'nowrap'
          }}>
            {change}
          </span>
        )}
      </div>
      {subtitle && <p style={{ fontSize: '14px', color: '#737373', marginTop: '2px', margin: 0 }}>{subtitle}</p>}
    </div>
  );
};

// Avatar with initials
export const Avatar = ({ initials, size = 'md', color }) => {
  const sizes = {
    sm: { width: '24px', height: '24px', fontSize: '10px' },
    md: { width: '32px', height: '32px', fontSize: '12px' },
    lg: { width: '40px', height: '40px', fontSize: '14px' },
  };
  
  const sizeStyle = sizes[size] || sizes.md;
  
  return (
    <div style={{
      ...sizeStyle,
      borderRadius: '50%',
      backgroundColor: color || '#1a1a1a',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '600'
    }}>
      {initials}
    </div>
  );
};

// Stacked Progress Bar
export const StackedProgressBar = ({ segments }) => (
  <div style={{ display: 'flex', height: '8px', borderRadius: '9999px', overflow: 'hidden', backgroundColor: '#f0f0f0' }}>
    {segments.map((segment, idx) => (
      <div
        key={idx}
        style={{ 
          height: '100%', 
          width: `${segment.percent}%`, 
          backgroundColor: segment.color,
          transition: 'all 0.5s'
        }}
      />
    ))}
  </div>
);

// Legend Item
export const LegendItem = ({ color, label, value }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 0' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: color }} />
      <span style={{ fontSize: '14px', color: '#737373' }}>{label}</span>
    </div>
    <span style={{ fontSize: '14px', fontWeight: '500', color: '#1a1a1a' }}>{value}</span>
  </div>
);

// Status Badge
export const StatusBadge = ({ status }) => {
  const isComplete = status === 'complete';
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: '6px 12px',
      borderRadius: '6px',
      fontSize: '13px',
      fontWeight: '500',
      backgroundColor: isComplete ? '#d1fae5' : '#fef3c7',
      color: isComplete ? '#059669' : '#b45309'
    }}>
      {isComplete ? 'Complete' : 'Incomplete'}
    </span>
  );
};

export default Card;
